import { render, staticRenderFns } from "./TableHeaderShareResource.vue?vue&type=template&id=066a1cdc&scoped=true"
import script from "./TableHeaderShareResource.vue?vue&type=script&lang=js"
export * from "./TableHeaderShareResource.vue?vue&type=script&lang=js"
import style0 from "./TableHeaderShareResource.vue?vue&type=style&index=0&id=066a1cdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066a1cdc",
  null
  
)

export default component.exports